/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1TargetgroupthemesQueryResponse } from '../../types/GetV1Targetgroupthemes.ts'

export const getV1TargetgroupthemesQueryKey = () => [{ url: '/v1/TargetGroupThemes' }] as const

export type GetV1TargetgroupthemesQueryKey = ReturnType<typeof getV1TargetgroupthemesQueryKey>

/**
 * {@link /v1/TargetGroupThemes}
 */
export async function getV1Targetgroupthemes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1TargetgroupthemesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/TargetGroupThemes`, ...requestConfig })
    return res
}

export function getV1TargetgroupthemesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1TargetgroupthemesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1TargetgroupthemesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1TargetgroupthemesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Targetgroupthemes(config)
        },
    })
}

/**
 * {@link /v1/TargetGroupThemes}
 */
export function useGetV1Targetgroupthemes<
    TData = ResponseConfig<GetV1TargetgroupthemesQueryResponse>,
    TQueryData = ResponseConfig<GetV1TargetgroupthemesQueryResponse>,
    TQueryKey extends QueryKey = GetV1TargetgroupthemesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1TargetgroupthemesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1TargetgroupthemesQueryKey()

    const query = useQuery(
        {
            ...getV1TargetgroupthemesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
